import { PlainDate } from "@sa-nu/shared-utils/date";

/**
 * マウント時にスクロールを合わせる日付。選択済み日程があればそちらを優先し、
 * 未選択のときだけ `initialVisibleDate` を描画範囲にクランプして使う。
 */
export function resolveInitialScrollDate({
  startDate,
  initialVisibleDate,
  minDate,
  renderMaxDate,
}: {
  startDate: PlainDate | null;
  initialVisibleDate: PlainDate | null | undefined;
  minDate: PlainDate;
  renderMaxDate: PlainDate;
}): PlainDate | null {
  if (startDate !== null) return startDate;
  if (initialVisibleDate == null) return null;
  if (PlainDate.compare(initialVisibleDate, minDate) < 0) return minDate;
  if (PlainDate.compare(initialVisibleDate, renderMaxDate) > 0) {
    return renderMaxDate;
  }
  return initialVisibleDate;
}
